import axios from 'axios';

class ServiceFileNodeCleanup {
  async runCleanup(): Promise<{ message: string; deletedFileNodes: number; blobsDeleted: number }> {
    const response = await axios.post('/api/file-nodes/cleanup-expired');
    return response.data;
  }
}

export default new ServiceFileNodeCleanup();
